import { YearPickerProps } from '@/domain/mitarbeiter/features/feiertagskonto/components/dateNavigation/types';
import { useYearPickerContext } from '@/domain/mitarbeiter/features/feiertagskonto/shared/YearPickerContext';
import {
  Button,
  Calendar,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@e2n/ui/v2';
import { useState } from 'react';

export function YearPicker({ className }: YearPickerProps) {
  const { year, setYear } = useYearPickerContext();
  const [open, setOpen] = useState(false);

  const handleSelectedYear = (selectedYear: number) => {
    setYear(year.year(selectedYear));
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost-on-grey" size="medium" className={className}>
          {year.format('YYYY')}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start">
        <PopoverBody>
          <Calendar
            mode="single"
            onYearSelect={handleSelectedYear}
            month={year.toDate()}
            showOutsideDays
            showTodayButton
            variant="year"
            className="w-auto border-none"
            captionLayout="dropdown"
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
